import React, { useEffect, useState } from "react";
import { IWDDesignModeProps, IWidgetTemplateProps, registerCardTemplate, registerMobileCardTemplate } from "../../../common/common";
import { SelectableItem, selectUIProps, selectUIPropsForMobileTempaltes } from "../../../common/SelectableItem";
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty";
import './IconSectionwidget.scss'
import { WidgetWrapperWithSidebar, createDefaultPropsForWidgetWrapperWithSidebar } from "../../../common/widget-wrappers/WidgetWrapperWithSidebar";
import { TextProperty } from "../../../common/ui-props/TextProperty";
import { IconSectionWidgetProperty, IIconButtonProps } from "./IconSectionwidgetProperty";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";
import { SimpleTextProperty } from "../../../common/ui-props/SimpleTextProperty";
import { TypeSelectorProperty } from "../../../common/ui-props/TypeSelectorProperty";
import classNames from "classnames";
import { hasValue, updateParentUIPropsWithDefaultWidgetUIProps } from "../../../../util";
import { SimpleNumberProperty } from "../../../common/ui-props/SimpleNumberProperty";
import ActionRenderComponent from "../../../common/components/ActionRenderComponent";
import { IAction } from "../../../common/action-editor/ActionEditor";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";
import { IContextProvider } from "../../../../uxp";


const newButton: IIconButtonProps = {
    icon: 'broom',
    label: 'Clean Up',
    iconColor: '#424242',
    backgroundColor: 'white',
    description: 'Clean up the meeting room',
}

const defaultButtons: IIconButtonProps[] = [
    {
        icon: 'brush',
        label: 'Cleaning',
        iconColor: 'white',
        backgroundColor: 'yellow',
        description: 'Clean your workstation'
    },
    {
        icon: 'powerOff',
        label: 'Control',
        iconColor: 'white',
        backgroundColor: 'limegreen',
        description: 'Controll your AC'
    }
]

interface IIconSectionComponent {
    buttons: IIconButtonProps[],
    designer: IWDDesignModeProps,
    instanceId: string,
    properties: any,
    uiProps: any
    field: string,
    isWeb?: boolean,
    uxpContext: IContextProvider,
    contextData: IContextData
}
const IconSectionComponent: React.FC<IIconSectionComponent> = (props) => {

    const { buttons, designer, instanceId, properties, uiProps, field, isWeb, uxpContext, contextData } = props
    const [actionData, setActionData] = React.useState<{ action: IAction, contextData: IContextData }>({ action: null, contextData: {} })

    function addNewButton(e: React.MouseEvent<HTMLDivElement>) {
        e.preventDefault()
        e.stopPropagation()

        let _uiProps = { ...uiProps || {} }
        if (!_uiProps.buttons) _uiProps.buttons = defaultButtons
        _uiProps.buttons.push(structuredClone(newButton))
        designer?.setMobileCardUIProps(instanceId, _uiProps, field)
    }

    function removeButton(removeIndex: number) {

        console.log('remove-button-index', removeIndex);

        let _uiProps = { ...uiProps || {} }
        if (!_uiProps.buttons) _uiProps.buttons = defaultButtons
        _uiProps.buttons = _uiProps.buttons.filter((b: any, i: number) => (i !== removeIndex))
        if (isWeb) {
            designer?.setUIProps(_uiProps)
        }
        else {
            designer?.setMobileCardUIProps(instanceId, _uiProps, field)
        }
    }


    function handleButtonClick(e: React.MouseEvent, item: IIconButtonProps) {
        e.preventDefault()
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            return
        }
        setActionData({ action: item.onClick, contextData: { ...contextData } })
        // setWidgetData({...contextData, row: item })
    }

    const numItems = uiProps?.buttonType?.numberOfButtons || 2
    //(100 / (uiProps?.buttonType?.numberOfButtons | 1)) + '%'
    const styles: any = {}
    if (isWeb) {
        styles.width = (100 / numItems) + '%'
    }
    else {
        if (uiProps.buttonType?.type === 'rectangle') {
            styles.width = '100%'
        }
    }

    const inDesignMode = (props?.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail'))

    return <div className={classNames("icon-section-widget-container", { "center": uiProps?.buttonType?.allignToCenter })} >
        {
            buttons?.map((button: IIconButtonProps, i: number) => {
                return <div className={classNames("icon-section-widget-icon-button-container", uiProps.buttonType?.type,
                    // { 'full-width': uiProps.buttonType?.type === 'rectangle' }
                )}
                    style={styles}
                >
                    <SelectableItem
                        designer={designer}
                        props={properties}
                        elementId={instanceId}
                        contextData={{ selectedIndex: i }}
                        key={i}
                    >
                        {uiProps.buttonType?.type === 'rectangle'
                            ? <div className="icon-section-widget-icon-button"
                                style={{
                                    backgroundColor: button.backgroundColor,
                                }}
                                onClick={e => (handleButtonClick(e, button))}
                            >

                                {inDesignMode ?
                                    <div className="icon-section-widget-icon-button-remove" onClick={() => removeButton(i)}>
                                        <FontAwesomeIcon icon={'times'} />
                                    </div>
                                    : null}

                                <div className={classNames("icon-section-widget-icon-button-icon-container")}
                                    style={{
                                        color: button.iconColor
                                    }}
                                >
                                    <FontAwesomeIcon icon={generateIconProp(button.icon)} />
                                </div>

                                <div className="icon-section-widget-icon-button-icon-label">
                                    <div className="icon-section-widget-icon-button-icon-label-title"
                                        style={{
                                            color: button.labelColor
                                        }}
                                    >
                                        {button.label}
                                    </div>
                                    <div className="icon-section-widget-icon-button-icon-label-description"
                                        style={{
                                            color: button.descriptionColor
                                        }}
                                    >
                                        {button.description}
                                    </div>
                                </div>
                            </div>
                            : <div className="icon-section-widget-icon-button"
                                onClick={e => (handleButtonClick(e, button))}
                            >
                                {inDesignMode ?
                                    <div className="icon-section-widget-icon-button-remove" onClick={() => removeButton(i)}>
                                        <FontAwesomeIcon icon={'times'} />
                                    </div>
                                    : null}

                                <div className={classNames("icon-section-widget-icon-button-icon-container", uiProps.buttonType?.type)}
                                    style={{
                                        backgroundColor: button.backgroundColor,
                                        color: button.iconColor
                                    }}
                                >
                                    <FontAwesomeIcon icon={generateIconProp(button.icon)} />
                                </div>

                                <div className="icon-section-widget-icon-button-icon-label">
                                    {button.label}
                                </div>
                            </div>
                        }

                    </SelectableItem>


                    <ActionRenderComponent
                        designer={designer}
                        uxpContext={uxpContext}
                        {...actionData}
                        onClose={() => setActionData({ action: null, contextData: {} })}
                        onReloadWidget={() => { }}
                    />

                </div>
            })
        }

        {inDesignMode &&
            <div className="icon-section-widget-icon-button-container"  >
                <div className="icon-section-widget-icon-button">
                    <div className="icon-section-widget-icon-button-icon-container add-new" onClick={addNewButton} >
                        <FontAwesomeIcon icon={['fas', 'plus']} style={{ color: '#424242' }} />
                    </div>
                </div>
            </div>
        }
    </div>
}


const IconSectionWidgetMobile: React.FunctionComponent<IWidgetTemplateProps> = (props) => {

    const { designer, uxpContext, params, instanceId, index } = props
    const field = props.dataKey == 'form' ? 'fields' : 'filter'

    let uiProps = props?.uiProps || { buttons: defaultButtons };
    let buttons = uiProps?.buttons || defaultButtons
    console.log('buttons ', buttons)

    // need to pass the global uiProps to selectable
    const parentUIProps = updateParentUIPropsWithDefaultWidgetUIProps(props.parentUIProps, uiProps, index)

    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
        'buttons': IconSectionWidgetProperty(buttons, uiProps.buttonType?.type || 'square'),
        'buttonType': TypeSelectorProperty({
            types: [
                { icon: 'solidCircle', value: 'circle' },
                { icon: 'solidSquare', value: 'square' },
                { icon: 'digitalTachograph', value: 'rectangle' },
            ],
            type: uiProps.type || 'square',
            itemWidth: '35px'
        }, 'Button Type')
    }, true)

    const properties = selectUIPropsForMobileTempaltes(parentUIProps, XPRProps, index, {}, 'buttons')

    const [loading, setLoading] = React.useState(false)
    const [contextData, setContextData] = React.useState<IContextData>({})
    const { isLoading, initialContextData } = useInitialContextData(props, [props?.uiProps?.source])

    React.useEffect(() => {
        setContextData(initialContextData)
        setLoading(isLoading)
    }, [isLoading, initialContextData])

    useEffect(() => {
        console.log('Icon section widget props ', uiProps)
    }, [uiProps])

    return <WidgetWrapperWithSidebar
        designer={designer}
        uiProps={uiProps}
        propDef={XPRProps}
        contextData={{}}
        elementId={instanceId}
        className="wd-mobile-icon-section-widget-wrapper"
        ignore={['buttons']}
        enableHideHeader={true}
        showContainerPropsLast={true}
        parentUIProps={parentUIProps}
        index={index}
    >
        <IconSectionComponent
            buttons={buttons}
            designer={designer}
            instanceId={props.instanceId}
            properties={properties}
            uiProps={uiProps}
            field={field}
            uxpContext={props.uxpContext}
            contextData={contextData}
        />
    </WidgetWrapperWithSidebar>
}

const IconSectionWidgetWeb: React.FunctionComponent<IWidgetTemplateProps> = (props) => {

    const { designer, uxpContext, params, instanceId, index } = props
    const field = props.dataKey == 'form' ? 'fields' : 'filter'

    let uiProps = props?.uiProps || { buttons: defaultButtons, buttonType: { type: 'rectangle', numberOfButtons: 2, allignToCenter: true } };
    if (!uiProps.buttons) uiProps.buttons = defaultButtons
    if (!uiProps.buttonType) uiProps.buttonType = { type: 'rectangle', numberOfButtons: 2, allignToCenter: true }
    let buttons = uiProps?.buttons || defaultButtons
    console.log('buttons ', buttons)


    const XPRProps = createDefaultPropsForWidgetWrapperWithSidebar({
        'chartContainer': ContainerProperty({background: {color: ''}, removeShadow: false}),
        'buttons': IconSectionWidgetProperty(buttons, uiProps.buttonType?.type || 'rectangle'),
        'buttonType': TypeSelectorProperty({
            types: [
                { icon: 'solidCircle', value: 'circle' },
                { icon: 'solidSquare', value: 'square' },
                { icon: 'digitalTachograph', value: 'rectangle' },
            ],
            type: uiProps.type || 'rectangle',
            itemWidth: '35px',
            numberOfButtons: 2,
            allignToCenter: true,
        }, 'Button Type', true)
    }, true)

    const properties = selectUIProps(uiProps, XPRProps, 'buttons') //selectUIPropsForMobileTempaltes(parentUIProps, XPRProps, index, {}, 'buttons')

    const [loading, setLoading] = React.useState(false)
    const [contextData, setContextData] = React.useState<IContextData>({})
    const { isLoading, initialContextData } = useInitialContextData(props, [props?.uiProps?.source])

    React.useEffect(() => {
        setContextData(initialContextData)
        setLoading(isLoading)
    }, [isLoading, initialContextData])

    useEffect(() => {
        console.log('Icon section widget props ', uiProps)
    }, [uiProps])

    return <WidgetWrapperWithSidebar
        designer={designer}
        uiProps={uiProps}
        propDef={XPRProps}
        contextData={{}}
        elementId={instanceId}
        className="wd-mobile-icon-section-widget-wrapper web"
        ignore={['buttons']}
        enableHideHeader={true}
        showContainerPropsLast={true}
        index={index}
    >
        <IconSectionComponent
            buttons={buttons}
            designer={designer}
            instanceId={props.instanceId}
            properties={properties}
            uiProps={uiProps}
            field={field}
            isWeb={true}
            uxpContext={props.uxpContext}
            contextData={contextData}
        />
    </WidgetWrapperWithSidebar>
}

registerMobileCardTemplate({
    id: 'mobile-icon-section',
    template: IconSectionWidgetMobile,
    name: 'Icon section',
    description: 'Icon section widget'
})

registerCardTemplate({
    id: 'icon-section-widget',
    template: IconSectionWidgetWeb,
    name: 'Icon section widget',
    description: 'Icon section widget',
    complexity: 'easy'
})